<template>
    <carousel
        :autoplayTimeout="5000"
        :items="1"
        :dots="false"
        :nav="false"
        :loop="true"
        >
        <component is="SalesReservationA"
            :refin="refin"
            :sorce="sorce" />
        <component is="SalesReservationB" 
            :refin="refin"
            :sorce="sorce" />
        <component is="SalesReservationC" 
            :refin="refin"
            :sorce="sorce" />
    </carousel>
</template>

<script>
import carousel from 'vue-owl-carousel'

import SalesReservationA from './SalesReservationA.vue';
import SalesReservationB from './SalesReservationB.vue';
import SalesReservationC from './SalesReservationC.vue';

export default {
    components: {
        carousel,
        SalesReservationA,
        SalesReservationB,
        SalesReservationC
    },
    data() {
        return {
            refin: '',
            sorce: ''
        }
    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        this.refin = urlParams.get('refin');
        this.sorce = urlParams.get('sorce');
    }
}
</script>
